import { Empty, Flex, Table, Tag } from "antd";
import { t } from "i18next";
import { useMemo } from "react";
import {
  calculateNedostajuceVrednosti,
  getRequestedStampsInfoTableColumns,
} from "../../../../../modules/obligee/exciseStamps/exciseStamps.functions";
import {
  IKategorijaVrstaZahtevaDtoProps,
  RequestedStampsInfoTableColumnName,
} from "../../../../../modules/obligee/exciseStamps/exciseStamps.types";
import style from "./RequestedStampsInfoTable.module.scss";

export const RequestedStampsInfoTable = ({
  requestedStampsInfo,
  hiddenColumns,
  expandable,
  title,
  editable,
  rowAction,
}: {
  requestedStampsInfo: Array<Partial<IKategorijaVrstaZahtevaDtoProps>>;
  expandable: boolean;
  hiddenColumns?: Array<RequestedStampsInfoTableColumnName>;
  title?: string;
  editable?: boolean;
  rowAction?: (index: number) => void;
}) => {
  const columns = useMemo(() => {
    return getRequestedStampsInfoTableColumns({
      hiddenColumns,
      editable,
      rowAction,
    });
  }, [hiddenColumns, editable, rowAction]);

  return (
    <Flex vertical style={{ paddingBottom: 20 }}>
      {title ? <span className={style.title}>{title}</span> : null}
      <Table
        columns={columns}
        dataSource={requestedStampsInfo}
        rowKey={(row) => row.markicaKategorijeVrsteId!}
        rowClassName={style.fontSize}
        expandable={{
          expandRowByClick: true,
          showExpandColumn: expandable,
          expandedRowRender: (row) => (
            <Flex vertical wrap="wrap" gap={20}>
              <strong>{t("AKCIZNE_MARKICE.NEDOSTAJUCE_VREDNOSTI")}</strong>
              <Flex wrap="wrap" align="center" gap={5}>
                {row.nedostajuceVrednosti?.map(
                  (nedostajucaVrednost: string) => (
                    <Tag className={style.fontSize}>{nedostajucaVrednost}</Tag>
                  )
                )}
              </Flex>
            </Flex>
          ),
          rowExpandable: (row) =>
            Boolean(calculateNedostajuceVrednosti(row.nedostajuceVrednosti)) &&
            expandable,
        }}
        locale={{
          emptyText: (
            <Empty
              description={t(
                "COMMON.NEMA_PODATAKA_O_TRAZENIM_AKCIZNIM_MARKICAMA"
              )}
            />
          ),
        }}
        pagination={false}
      />
    </Flex>
  );
};
